export default __webpack_public_path__ + "static/project-slide-5-1248-765-ac22bbacbaee2ab01b8d78bad9149e13.webp";